import React from 'react'

const TablaVerSuministrosDevolucionQxFarmacia = ({item}) => {
  return (
    <tbody>
      {/* {item.PaqAct === 'S'? */}
      <tr className=" divide-y divide-slate-700 ">
        
        <td></td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.ProCirCod}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PaqCod.trim()}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PaqDes}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.MSRESO}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.MSNomG}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PQCaSuDs}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PQCaSuUs}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PQCaSuDv}
        </td>
        {/* <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PQCaSuDv}
        </td> */}
      </tr>
      {/* :
      null

    } */}
    </tbody>
  )
}

export default TablaVerSuministrosDevolucionQxFarmacia